<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :title="$t('Modify') + ' ' + $t('a.user')"/>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">
        <b-form @submit.stop.prevent="onSubmit">
          <b-form-group
            id="firstName-input"
            :label="$t('FirstName')+'*'"
            label-for="firstName-input"
            class="bold-label"
            :invalid-feedback="form.firstName.invalidFeedback"
            :state="form.firstName.state"
          >
            <b-form-input
              id="firstName-input"
              v-model="form.firstName.value"
              type="text"
              maxlength="250"
              :state="form.firstName.state"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="lastName-input"
            :label="$t('LastName')+'*'"
            label-for="lastName-input"
            class="bold-label"
            :invalid-feedback="form.lastName.invalidFeedback"
            :state="form.lastName.state"
          >
            <b-form-input
              id="lastName-input"
              v-model="form.lastName.value"
              type="text"
              maxlength="250"
              :state="form.lastName.state"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="username-input"
            :label="$t('user.Username')+'*'"
            label-for="username-input"
            class="bold-label"
            :invalid-feedback="form.username.invalidFeedback"
            :state="form.username.state"
          >
            <b-form-input
              id="username-input"
              v-model="form.username.value"
              type="email"
              maxlength="250"
              :state="form.username.state"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="isUnlimited-input"
            :label="$t('user.IsUnlimited')"
            label-for="isUnlimited-input"
            class="bold-label row col-6"
            :invalid-feedback="form.isUnlimited.invalidFeedback"
            :state="form.isUnlimited.state"
          >
            <b-form-checkbox
              v-model="form.isUnlimited.value"
              :state="form.isUnlimited.state"
              name="isUnlimited-button"
              class="unlimited-switch"
              switch>
            </b-form-checkbox>
          </b-form-group>
          <b-form-group
            v-if=!form.isUnlimited.value
            id="nbQuestionnaireRestant-input"
            :label="$t('user.NbQuestionnaireRestant') + '*'"
            label-for="nbQuestionnaireRestant-input"
            class="bold-label"
            :invalid-feedback="form.nbQuestionnaireRestant.invalidFeedback"
            :state="form.nbQuestionnaireRestant.state"
          >
            <b-form-input
              id="nbQuestionnaireRestant-input"
              v-model="form.nbQuestionnaireRestant.value"
              type="number"
              :state="form.nbQuestionnaireRestant.state"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="rpps-input"
            :label="$t('user.rpps')+'*'"
            label-for="rpps-input"
            class="bold-label"
            :invalid-feedback="form.rpps.invalidFeedback"
            :state="form.rpps.state"
          >
            <b-form-input
              id="rpps-input"
              v-model="form.rpps.value"
              type="number"
              maxlength="250"
              :state="form.rpps.state"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="partnerCode-input"
            :label="$t('user.partnerCode')"
            label-for="partnerCode-input"
            class="bold-label"
            :invalid-feedback="form.partnerCode.invalidFeedback"
            :state="form.partnerCode.state"
          >
            <b-form-input
              id="partnerCode-input"
              v-model="form.partnerCode.value"
              type="number"
              maxlength="250"
              :state="form.partnerCode.state"
            ></b-form-input>
          </b-form-group>

          <PasswordCreationField
            :isEdit="true"
            @passwordInfos="getPasswordInfos"
          ></PasswordCreationField>

          <div class="d-flex justify-content-end">
            <b-button type="submit" variant="primary">{{ $t('Validate') }}</b-button>
          </div>
        </b-form>
      </b-card>
    </b-container>
  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/b122/BackArrow";
import DateField from "../../components/b122/DateField";
import PasswordCreationField from "../../components/b122/PasswordCreationField";

export default {

  name: 'UserEdit',

  components: {
    BackArrow,
    DateField,
    PasswordCreationField
  },

  data() {
    return {
      userId: this.$route.params.userId,
      form: {
        password: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        firstName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        lastName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        username:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        isUnlimited:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        nbQuestionnaireRestant:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        rpps:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        partnerCode:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
      }
    }

  },

  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.fetchUser()
    },

    fetchUser() {
      api
        .get(`/user/${this.userId}`)
        .then(response => {
          this.user = response.data
          this.setInitialValues()
        })
    },

    setInitialValues() {
      this.form.username.value = this.user.username
      this.form.firstName.value = this.user.firstName
      this.form.lastName.value = this.user.lastName
      this.form.isUnlimited.value = this.user.isUnlimited
      this.form.nbQuestionnaireRestant.value = this.user.nbQuestionnaireRestant
      this.form.rpps.value = this.user.rpps
      this.form.partnerCode.value = this.user.partnerCode
    },

    onSubmit() {
      let data = new FormData()
      data.append('password', this.form.password.value)
      data.append('username', this.form.username.value)
      data.append('firstName', this.form.firstName.value)
      data.append('lastName', this.form.lastName.value)
      data.append('isUnlimited', this.form.isUnlimited.value)
      data.append('nbQuestionnaireRestant', this.form.nbQuestionnaireRestant.value)
      data.append('rpps', this.form.rpps.value)
      if (this.form.partnerCode.value && this.form.partnerCode.value.trim() !== "") {
        data.append('partnerCode', this.form.partnerCode.value)
      }

      api({
        method: 'POST',
        url: `/user/${this.user.id}`,
        data: data
      })
        .then((response) => {
          this.$router.push({
            name: 'UserShow',
            params: {
              userId: this.user.id
            }
          }, () => {
            this.$nextTick(() => {
              this.successToast(this.form.username.value)
            })
          })
        })
        .catch((error) => {
          if (error.response.status === 418) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]["state"] = false
            this.form[invalidField]["invalidFeedback"] = error.response.data.message
          }
        });
    },

    successToast(username) {
      this.$bvToast.toast(this.$i18n.t('User') + ' "' + username + '" ' + this.$i18n.t('modify'), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    getPasswordInfos(state, invalidFeedBack, value) {
      this.form.password.state = state;
      this.form.password.invalidFeedback = invalidFeedBack;
      this.form.password.value = value;
    },

  }
}
</script>

<style scoped>
.unlimited-switch {
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/user/UserEdit.vue